<template>
  <b-modal title="Lista de Imagens" v-model="show" size="xl">
    <div class="modal-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE IMAGENS :::::::::::::::::::::::::::: -->
      <b-table id="table-img" bordered hover small head-variant="light" :items="getFilterImagens(filtro)" :fields="fields.imagem">
        <template #cell(data)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ moment(data.item.data).format("DD/MM/YYYY") }}
            </p>
          </div>
        </template>
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="display(data.item)">
              <b-icon icon="image" variant="info"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="carregar(data.item)" v-b-tooltip.hover title="Carregar">
              <b-icon icon="cloud-arrow-down-fill" variant="info"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: MODAIS DE USO :::::::::::::::::::::::::::: -->
    <display-modal ref="display" :size="'sm'" />

    <template #modal-footer>
      <b-form inline>
        <b-icon icon="search" variant="primary" scale="1.2" class="m-1" />
        <b-form-input
          id="imagem-filter"
          type="search"
          size="sm"
          class="m-1 p-1"
          placeholder="Filtre pela descrição da imagem."
          v-model="filtro"
        />
      </b-form>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useImagemStore } from "@/stores/ImagemStore";
import TableFields from "@/tools/TableFields";
import DisplayModal from "@/components/modals/diversos/DisplayModal";
import Files from "@/http/files";

export default {
  name: "ImagemListModal",

  data() {
    return {
      show: false,
      fields: new TableFields(),
      filtro: "",
      files: new Files(this.$http),
    };
  },

  components: {
    "display-modal": DisplayModal,
  },

  methods: {
    display(imagem) {
      this.files.downloadImagem(imagem.id).then((response) => this.$refs.display.call(response));
    },

    carregar(imagem) {
      this.files.downloadImagem(imagem.id).then((image) => {
        const reader = new FileReader();
        const blob = new Blob([image]);
        reader.readAsDataURL(blob);
        reader.onload = (e) => {
          this.$emit("loadImagem", e.target.result);
          this.show = !this.show;
        };
      });
    },

    call() {
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const imagemStore = useImagemStore();
    const { getFilterImagens } = storeToRefs(imagemStore);

    return {
      store,
      imagemStore,
      getFilterImagens,
    };
  },
};
</script>

<style lang="scss" scoped>
#imagem-filter {
  width: 22rem;
}
</style>
